import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isNil } from 'ramda';
export var CornerCase = /*#__PURE__*/_createClass(function CornerCase(val) {
  _classCallCheck(this, CornerCase);
  _defineProperty(this, "val", void 0);
  this.val = val;
});
export var Data = /*#__PURE__*/_createClass(function Data(val) {
  _classCallCheck(this, Data);
  _defineProperty(this, "val", void 0);
  this.val = val;
});
/**
 * Попытка стандартизировать отрисовку неосновных сценариев (экран ошибки, экран загрузки и тд)
 * Проблема. До того, как данные для какой-либо фичи загрузились, происходит несколько стадий:
 * загрузка еще не начиналась, загрузка длится, загрузка неуспешна, загрузка успешна но данные пустые.
 * Под каждый сценарий у нас обычно бывает своя вьюшка (экран ошибки, экран с прелоадером, экран "Данных нет")
 * Сложная система условий вынесена в хук
 * Классы CornerCase и Data назначены для того, чтоб с помощью instanceOf отличать, что вернулось из хука
 * Если вернулся CornerCase - рисуем его, иначе - вернулись данные, которые точно есть и непустые (NonNullable<T>)
 * @example
 * function Container() {
 *   const {someNullableData, isFetching, isError} = useData;
 *
 *   const dataLifecycle = useDataLifecycleStepsRender({data: someNullableData, isFetching, isError});
 *
 *   if (dataLifecycle instanseOf CornerCase) {
 *     return dataLifecycle.val; //Рисуем неосновной сценарий
 *   }
 *
 *   //после проверки на instanceOf CornerCase, данные (dataLifecycle.val) уже точно будут
 *   return <Component data={dataLifecycle.val} />
 * }
 * */
export function useDataLifecycleStepsRender(params) {
  var data = params.data,
    isError = params.isError,
    isFetching = params.isFetching,
    emptyData = params.emptyData,
    error = params.error,
    notLoaded = params.notLoaded,
    preloader = params.preloader,
    _params$isEmpty = params.isEmpty,
    isEmpty = _params$isEmpty === void 0 ? isNil : _params$isEmpty;
  if (isError) {
    return new CornerCase(error || null);
  }

  /** Если загрузка еще не была начата (т.е нет даже старых данных с прошлой загрузки) */
  if (isFetching === undefined) {
    return new CornerCase(notLoaded || null);
  }
  if (isEmpty(data)) {
    /** Если нет данных и при этом загрузка в процессе */
    if (isFetching) {
      return new CornerCase(preloader || null);
    }

    /** Если нет данных и при этом загрузка завершена и нет ошибки - значит данные загрузились, но они пусты. */
    return new CornerCase(emptyData || null);
  }
  return new Data(data);
}